module.exports = __webpack_public_path__ + "static/media/03_thumbnail.660788a5.jpg";